import { EventTypeEnum } from '@unifyapps/defs/types/event';
import type { Event } from '@unifyapps/defs/types/event';
import type { EmitActionParams } from '@unifyapps/defs/hooks/useBlockAction';
import type { Notification as NotificationType } from '@unifyapps/network/generated/models/notification';
import type { SyntheticEvent } from '@unifyapps/defs/types/syntheticEvent';
import type { KeyboardShortcut } from '@unifyapps/defs/blocks/common/keyboardShortcut';
import { EMPTY_ARRAY } from '../../../consts/empty';
import { isKeyboardShortcutEvent } from '../../../utils/keyboardShortcut';

export function getEventsToTrigger({
  events,
  actionContext,
  eventType,
  domEvent,
}: {
  events: Event[];
  eventType: string;
  actionContext?: EmitActionParams['actionContext'];
  domEvent?: SyntheticEvent;
}) {
  switch (eventType) {
    case EventTypeEnum.OnReceiveNotification: {
      return events.filter(
        (event) =>
          event.payload?.notificationType &&
          event.payload.notificationType ===
            (actionContext as { notification?: NotificationType } | undefined)?.notification?.id,
      );
    }
    case EventTypeEnum.OnKeyboardShortcut: {
      if (!domEvent) return EMPTY_ARRAY as Event[];

      return events.filter(
        (event) =>
          event.payload?.shortcut &&
          isKeyboardShortcutEvent(
            domEvent as KeyboardEvent,
            event.payload.shortcut as KeyboardShortcut,
          ),
      );
    }
    default: {
      return events;
    }
  }
}
